import { WorkPolicyApplicationApiError } from "../../../../api/work-policy-application-api";

const messageByCode: Record<string, string> = {
  WORK_POLICY_UNAUTHORIZED: "로그인이 필요합니다.",
  WORK_POLICY_VALIDATION: "신청 내용을 확인해 주세요.",
  WORK_POLICY_NOT_FOUND: "근무제 신청 문서를 찾지 못했습니다.",
  WORK_POLICY_FORBIDDEN: "이 결재 문서를 확인할 권한이 없습니다.",
  WORK_POLICY_STAGE_FAILED:
    "저장 중 문제가 발생했습니다. 입력값은 유지되었습니다.",
  WORK_POLICY_STALE:
    "저장된 신청 내용이 변경되었습니다. 다시 불러온 뒤 확인해 주세요.",
  WORK_POLICY_DB_DEPENDENCY:
    "서버 연결 상태를 확인하고 잠시 후 다시 시도해 주세요.",
  WORK_POLICY_NETWORK_UNKNOWN: "서버 응답을 확인하지 못했습니다.",
  WORK_POLICY_INTERNAL: "근무제 신청을 처리하지 못했습니다.",
  WORK_POLICY_APPLICATION_FAILED: "근무제 신청을 저장하지 못했습니다."
};

const containsKorean = (message: string) => /[가-힣]/.test(message);

export function workPolicyApplicationErrorMessage(error: unknown): string {
  if (error instanceof WorkPolicyApplicationApiError) {
    const detailedMessage = error.issues?.find(issue =>
      containsKorean(issue.message)
    )?.message;
    return (
      detailedMessage ??
      messageByCode[error.code] ??
      "근무제 신청을 처리하지 못했습니다."
    );
  }
  if (error instanceof Error && containsKorean(error.message)) {
    return error.message;
  }
  return "근무제 신청을 처리하지 못했습니다.";
}
